import { Component, OnInit } from '@angular/core';
import { GLOBAL } from 'src/app/app.globals';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  version = GLOBAL.APP_VERSION;
  currentYear = (new Date()).getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
